import e from "react";
const a = ({ children: t, maxChildren: o, componentName: r, additionalInfo: c }) => {
  if (!(!t || !o) && e.Children.count(t) > o)
    throw new Error(`${r} component can have a maximum of ${o} children. ${c}`);
};
export {
  a as c
};
